( function () {
	const TABLISTS = document.querySelectorAll( '.tabs' );

	TABLISTS.forEach( ( TABLIST ) => {
		const TABS = [ ...TABLIST.querySelectorAll( '.tab' ) ];
		const TABPANELS = [ ...TABLIST.querySelectorAll( '.tabpanel' ) ];

		const showActivePanel = ( element ) => {
			const selectedId = element.id;
			TABPANELS.forEach( ( e ) => {
				e.hidden = 'true';
			} );
			const activePanel = TABLIST.querySelector(
				`[aria-labelledby="${ selectedId }"]`
			);
			activePanel.removeAttribute( 'hidden' );
			//activePanel.focus();
		};

		const setSelectedTab = ( element ) => {
			const selectedId = element.id;
			TABPANELS[ 0 ].classList.remove( 'visible' );

			TABS.forEach( ( e ) => {
				const id = e.getAttribute( 'id' );
				if ( id === selectedId ) {
					e.removeAttribute( 'tabindex', '0' );
					e.setAttribute( 'aria-selected', 'true' );
				} else {
					e.setAttribute( 'tabindex', '-1' );
					e.setAttribute( 'aria-selected', 'false' );
				}
			} );
		};

		const createArrowNavigation = () => {
			const firstTab = TABS[ 0 ];
			const lastTab = TABS[ TABS.length - 1 ];

			TABS.forEach( ( element ) => {
				element.addEventListener( 'keydown', function ( e ) {
					if (
						( e.keyCode || e.which ) === 38 ||
						( e.keyCode || e.which ) === 37
					) {
						if ( element === firstTab ) {
							e.preventDefault();
							lastTab.focus();
						} else {
							e.preventDefault();
							const focusableElement =
								TABS.indexOf( element ) - 1;
							TABS[ focusableElement ].focus();
						}
					} else if (
						( e.keyCode || e.which ) === 40 ||
						( e.keyCode || e.which ) === 39
					) {
						if ( element === lastTab ) {
							e.preventDefault();
							firstTab.focus();
						} else {
							e.preventDefault();
							const focusableElement =
								TABS.indexOf( element ) + 1;
							TABS[ focusableElement ].focus();
						}
					}
				} );
			} );
		};

		const determineTabindex = () => {
			TABPANELS.forEach( ( element ) => {
				const focusableElements = element.querySelectorAll(
					'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
				).length;

				// eslint-disable-next-line no-unused-expressions
				focusableElements
					? element.setAttribute( 'tabindex', '-1' )
					: element.setAttribute( 'tabindex', '0' );
			} );
		};

		const handleClick = () => {
			TABS.forEach( ( element ) => {
				element.addEventListener( 'click', function () {
					setSelectedTab( element );
					showActivePanel( element );
				} );
			} );

			TABS.forEach( ( element ) => {
				element.addEventListener( 'keydown', function ( e ) {
					if ( ( e.keyCode || e.which ) === 32 ) {
						setSelectedTab( element );
						showActivePanel( element );
						element.click();
					}
				} );
			} );
		};

		const activateFirstPanel = () => {
			TABS[ 0 ].setAttribute( 'tabindex', '0' );
			TABS[ 0 ].setAttribute( 'aria-selected', 'true' );
			TABPANELS[ 0 ].classList.add( 'visible' );
		};

		const checkInitialSelectedTab = () => {
			const targetedTabPanel =
				TABLIST.querySelector( '.tabpanel:target' ).getAttribute(
					'aria-labelledby'
				);
			const selectedTab = TABLIST.querySelector(
				`#${ targetedTabPanel }`
			);
			selectedTab.setAttribute( 'aria-selected', 'true' );
			selectedTab.removeAttribute( 'tabindex' );
		};

		const handleInitialState = () => {
			TABS.forEach( ( e ) => {
				e.setAttribute( 'tabindex', '-1' );
				e.setAttribute( 'aria-selected', 'false' );
			} );
			// eslint-disable-next-line no-unused-expressions
			window.location.href.indexOf( '#panel' ) === -1
				? activateFirstPanel()
				: checkInitialSelectedTab();

			determineTabindex();

			const firstPanel = TABPANELS[ 0 ];
			if ( ! window.location.hash ) {
				firstPanel.removeAttribute( 'hidden' );
				firstPanel.setAttribute( 'aria-hidden', 'false' );
				TABS[ 0 ].setAttribute( 'aria-selected', 'true' );
				TABS[ 0 ].removeAttribute( 'tabindex' );
			}
		};

		handleClick();
		createArrowNavigation();

		window.onload = handleInitialState;
	} );
} )();
